import { createApp } from 'vue'
// import VueMeta from 'vue-meta'
import VueNumerals from 'vue-numerals'
// import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/styles/index.css'

const shop = createApp(App)
shop.use(VueNumerals, {
  locale: 'de'
}) // default locale is 'en'
shop
  .use(store)
  .use(router)
  // .use(VueMeta, {
  //   keyName: 'metaInfo',
  //   attribute: 'data-vue-meta',
  //   ssrAttribute: 'data-vue-meta-server-rendered',
  //   tagIDKeyName: 'vmid',
  //   refreshOnceOnNavigation: true
  // })
  // .use(VueMeta)
  .mount('#shop')
